import { LocationsTree } from 'components/hierarchy/LocationsTree';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { AlarmThresholdFormFields } from './shared';
import { validateGroupIds } from './validation';

type LocationSelectionFieldProps = Readonly<{
    hideIndicatorGroups?: boolean;
    rootGroupIds?: string[];
}>;

export function LocationSelectionField({
    hideIndicatorGroups = false,
    rootGroupIds,
}: LocationSelectionFieldProps) {
    const { control } = useFormContext<AlarmThresholdFormFields>();
    const [expandedGroupIds, setExpandedGroupIds] = useState<string[]>(
        rootGroupIds ?? [],
    );

    return (
        <Controller
            name="groupIds"
            control={control}
            rules={{
                validate: validateGroupIds,
            }}
            render={({ field: { value, onChange } }) => (
                <LocationsTree
                    selectedGroupIds={value}
                    expandedGroupIds={expandedGroupIds}
                    onSelectedChange={onChange}
                    onExpandedChange={setExpandedGroupIds}
                    hideIndicatorGroups={hideIndicatorGroups}
                    rootGroupIds={rootGroupIds}
                />
            )}
        />
    );
}
